import { asNetworkAware } from '../../utils/network-error';
import { fechFromBPartsApi } from '../utils';

export const setLanguage = ({
  locale,
  language,
  url_path,
  csrftoken,
}: {
  locale: string;
  language: string;
  url_path?: string;
  csrftoken: string;
}): Promise<{ old_url_path: string | null } | { value: string }> => {
  const endpoint = `/${locale}/shop/languages/change`;

  // Mesma razão que em `slug_translation`: este pedido corre logo a seguir, no
  // mesmo `translateUrl`, e é abortado pelo `window.location.replace` que a
  // mudança de país dispara. Só o `fetch` vai dentro do wrapper — a leitura do
  // payload fica de fora para que uma resposta inesperada continue a ser nossa.
  return asNetworkAware(
    `PUT ${endpoint}`,
    fechFromBPartsApi<Response>(endpoint, {
      method: 'PUT',
      headers: new Headers([
        ['Content-Type', 'application/json'],
        ['X-CSRFToken', csrftoken],
      ]),
      credentials: 'include',
      body: JSON.stringify({ value: language, ...(url_path && { url_path }) }),
    })
  ).then(async (value) => {
    const json = await value.json();

    if (value.status >= 400 && value.status < 600) {
      throw json;
    }

    return json;
  });
};
